module.exports = __webpack_public_path__ + "c6df4bb3230688d0181c84ccfb42ccda.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/harvard_university.png
// module id = 2028
// module chunks = 0